import { useParams } from 'react-router-dom';
import './Gallery.css';
import { createGlobalStyle } from 'styled-components';
import { useState } from 'react';
import useSlideshow from './hooks/useSlideshow';
import useSlideshowDisplay from './hooks/useSlideshowDisplay';
import SlideshowSettingsModal from './SlideshowSettingsModal';
import { Button } from '@/src/shadComponents/ui/button';
import SlideshowViewer from './SlideshowViewer';

interface DefaultThemeProps {
    foregroundColor?: string;
    backgroundColor?: string;
    headerBackgroundColor?: string;
    headerForegroundColor?: string;
}
const GlobalStyle = createGlobalStyle`
body {
        color: ${({ foregroundColor }: DefaultThemeProps) =>
            foregroundColor || '#000'};
        background-color: ${({ backgroundColor }: DefaultThemeProps) =>
            backgroundColor || '#FFF'};;
}

.Fullscreen-modal {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;

}

.Share-form input {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};
    border-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    border-style:solid;
    font-family: 'Roboto', sans-serif;
}

.Share-form .Link-button {
    background-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.SB-Modal {
    color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.Gallery-cell.expanded {
color: ${({ foregroundColor }: DefaultThemeProps) => foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.Gallery-cell.expanded > .options {
color: ${({ foregroundColor }: DefaultThemeProps) => foregroundColor || '#000'};
    background-color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};;
}

.cta-button {
    background-color: ${({ foregroundColor }: DefaultThemeProps) =>
        foregroundColor || '#000'};
    color: ${({ backgroundColor }: DefaultThemeProps) =>
        backgroundColor || '#FFF'};
    }

.Gallery-header {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || '#000'};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.Gallery-name {
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

.Find-your-own-photos-banner {
    background-color: ${({ headerBackgroundColor }: DefaultThemeProps) =>
        headerBackgroundColor || '#000'};
    color: ${({ headerForegroundColor }: DefaultThemeProps) =>
        headerForegroundColor || '#FFF'};
}

`;

export default function Slideshow() {
    const { slug } = useParams();
    const { photos, isLoading, gallery } = useSlideshow(slug || '');
    const settings = useSlideshowDisplay();

    const [showSettingsModal, setShowSettingsModal] = useState(false);

    if (!gallery && !isLoading) {
        return (
            <div>
                <h3>gallery not found...</h3>
            </div>
        );
    }

    return (
        <div className="Gallery-view overflow-hidden">
            <GlobalStyle
                foregroundColor={gallery?.foregroundColor}
                backgroundColor={gallery?.backgroundColor}
                headerBackgroundColor={gallery?.headerBackgroundColor}
                headerForegroundColor={gallery?.headerForegroundColor}
            />
            {gallery && (
                <SlideshowViewer
                    isLoading={isLoading}
                    gallery={gallery}
                    photos={photos}
                    {...settings}
                />
            )}
            <div className="absolute bottom-0 right-0 z-index">
                <Button
                    onClick={() => setShowSettingsModal(true)}
                    className="Primary-button hide-after-timeout"
                >
                    Settings
                </Button>
            </div>
            {gallery && showSettingsModal && (
                <SlideshowSettingsModal
                    gallery={gallery}
                    {...settings}
                    setShowModal={setShowSettingsModal}
                />
            )}
        </div>
    );
}
